import {NgModule} from '@angular/core';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {PreloadAllModules, RouterModule, Routes} from "@angular/router";
import {Constants} from "./modules/constants";
import {LandingComponent} from "./modules/landing/landing.component";
import {ShareListComponent} from "./modules/social/share-list.component";
import {ReferralCreditComponent} from "./modules/referral/referral-credit.component";
import {LogoutComponent} from "./modules/auth/logout.component";
import {ProductComponent} from "./modules/product/product.component";
import {ReloadComponent} from "./modules/common/reload.component";
import {ConfirmExitGuard} from "./modules/route-guards/confirm-exit.guard";
import {PayPalTokenComponent} from "./modules/payment/paypal/paypal-token.component";
import {UserRolesGuard} from "./modules/route-guards/user-roles.guard";
import {CartOverviewComponent} from "./modules/cart/cart-overview/cart-overview.component";
import {SurveyResultsComponent} from "./modules/survey/survey-results.component";
import {NewCheckoutGuard} from "./modules/route-guards/new-checkout.guard";
import {PaymentCallbackComponent} from "./modules/payment/payment-callback.component";

const appRoutes: Routes = [
    {
        path: ':locale',
        canActivate: [UserRolesGuard],
        canActivateChild: [UserRolesGuard],
        children: [
            {
                path: Constants.AUTO_ORDER_STATE,
                loadChildren: () => import('./modules/autoorder/autoorder.module')
                    .then(module => module.AutoorderModule)
            },
            {
                path: Constants.MHP_STATE,
                loadChildren: () => import('./modules/mhp/mhp.module')
                    .then(module => module.MhpModule)
            },
            {
                path: Constants.CHECKOUT_STATE,
                canLoad: [NewCheckoutGuard],
                loadChildren: () => import('./checkout/checkout.module')
                    .then(module => module.CheckoutModule)
            },
            {
                path: Constants.CBEC_STATE,
                loadChildren: () => import('./cbec/cbec.module')
                    .then(module => module.CbecModule)
            },
            {
                path: Constants.AFFILIATE_STATE,
                loadChildren: () => import('./modules/affiliate/affiliate.module')
                    .then(module => module.AffiliateModule)
            },
            {
                path: Constants.ENROLL_STATE,
                loadChildren: () => import('./modules/enroll/enroll.module')
                    .then(module => module.EnrollModule)
            },
            {
                path: Constants.LANDING_STATE,
                component: LandingComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    restrict: [Constants.ROLES.NFR_MHP_ONLY, Constants.ROLES.CBEC]
                }
            },
            {
                path: Constants.CART_OVERVIEW_STATE,
                component: CartOverviewComponent,
            },
            {
                //queryParam option: {shareListId: number}
                path: Constants.SHARE_LIST_STATE,
                component: ShareListComponent,
                data: {
                    roles: [Constants.ROLES.ASSOCIATE, Constants.ROLES.PC, Constants.ROLES.AFFILIATE],
                    restrict: [Constants.ROLES.NFR_MHP_ONLY, Constants.ROLES.EVENT]
                }
            },
            {
                path: Constants.REFERRAL_CREDIT_STATE,
                component: ReferralCreditComponent,
                data: {
                    roles: [Constants.ROLES.PC],
                    restrict: [Constants.ROLES.EVENT]
                }
            },
            {
                path: Constants.PAYPAL_TOKEN_STATE,
                component: PayPalTokenComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                }
            },
            {
                path: Constants.PRODUCT_STATE + '/:usanaId',
                component: ProductComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.PRODUCT_STATE + '/:usanaId/:readableUrl',
                component: ProductComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                //queryParam option: {goToLogin: boolean}
                path: Constants.LOGOUT_STATE,
                component: LogoutComponent,
                data: {
                    roles: [Constants.ROLES.ALWAYS]
                }
            },
            {
                //queryParam option: {url: string}
                path: Constants.RELOAD_STATE,
                component: ReloadComponent,
                data: {
                    roles: [Constants.ROLES.ALWAYS]
                }
            },
            {
                //queryParam option: {surveyId: number}
                path: Constants.SURVEY_RESULTS_ROUTE,
                component: SurveyResultsComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    restrict: [Constants.ROLES.NFR, Constants.ROLES.NFR_MHP_ONLY, Constants.ROLES.CBEC, Constants.ROLES.EVENT]
                }
            },
            {
                path: Constants.PAYMENT_CALLBACK_STATE + '/notify/:paymentMethodType/:paymentId',
                data: {
                    mode: 'notify'
                },
                component: PaymentCallbackComponent
            },
            {path: '', redirectTo: 'landing', pathMatch: 'full'},
            {path: "**", redirectTo: 'landing', pathMatch: 'full'},
        ]
    },
    {path: '', redirectTo: 'en-US/landing', pathMatch: 'full'},
    {path: "**", redirectTo: 'en-US/landing', pathMatch: 'full'},
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
    scrollPositionRestoration: 'top',
    // enableTracing: true,
    preloadingStrategy: PreloadAllModules
})
    ],
    exports: [
        RouterModule
    ],
    providers: [
        ConfirmExitGuard,
        UserRolesGuard,
        NewCheckoutGuard,
        {provide: LocationStrategy, useClass: PathLocationStrategy},
    ]
})
export class AppRoutingModule {
}
